<template>
  <b-modal
    v-model="dataModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    title="Start Auto Calls"
    @close="onCloseModal">
    <div class="model-project-settings">
      <call-input
        v-model="$v.dataForm.name.$model"
        type-input="text"
        :valide="$v.dataForm.name.$error"
        float-name-label="Name" />
      <template v-if="dataAutoCallProjectsSettings.type === 'main'">
        <div class="upload__title">
          Select amount of open tasks to be sorted out
        </div>
        <div
          :class="[
            'call-select-modal__wrapper',
            'call-input',
            !dataForm.countTasks ? 'call-select--empty' : null
            // $v.dataForm.countTasks.$error ? 'error-valide' : null
          ]">
          <v-select
            v-model="dataForm.countTasks"
            :options="dataSelectOptionsCountTasks"
            label="name"
            placeholder="Tasks"
            :clearable="false"
            :components="{ Deselect: dataComponentDeselect }"
            class="call-select-modal call-select">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template slot="no-options">
              Enter the name of Team Leader
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
          </v-select>
          <label>Tasks</label>
        </div>
      </template>

      <template v-else>
        <div class="model-project-settings__cts-wrap">
          {{ dataAutoCallProjectsSettings.selectedTaskIds.length }}
          Сustom Tasks Selected
        </div>
      </template>

      <div
        v-if="dataAutoCallProjectsSettings.type === 'main'"
        class="upload__title">
        Select period of auto calls
      </div>
      <div
        v-else
        class="upload__title">
        Select period
      </div>

      <CallWeekdaySelector v-model="dataForm.weekday" />

      <time-picker-custom
        v-model="dataForm.time" />
    </div>

    <template #modal-footer>
      <call-button
        :icon="dataCloseIcon"
        type="danger"
        plain
        @click="onCloseModal()">
        Cancel
      </call-button>
      <call-button
        :icon="dataIconPlay"
        :disabled="$v.$invalid"
        type="success"
        @click="clickAdd()">
        Play
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { faPlay } from '@fortawesome/pro-regular-svg-icons';

import CallButton from '../CallButton';
import CallWeekdaySelector from '../CallWeekdaySelector';
import { validationMixin } from 'vuelidate';
import { AUTOCALL_UPDATE, AUTOCALL_CUSTOM } from '../../../store/types/actions.types';
import iconsModal from '../../../mixins/iconsModal';
import selectTeamLeader from '../../../mixins/select/selectTeamLeader';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import CallInput from '../CallInput';
import TimePickerCustom from '../TimePickerCustom';

export default {
  name: 'CallUpdateProjectSettings',
  components: {
    CallButton,
    BModal,
    CallWeekdaySelector,
    CallInput,
    TimePickerCustom
  },
  mixins: [validationMixin, iconsModal, selectTeamLeader],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: [String, Number],
      default: false,
      required: true
    },
    projectData: {
      type: Object,
      default: false,
      required: true
    },
    dataAutoCallProjectsSettings: {
      type: Object,
      default: () => ({
        type: 'main',
        selectedTaskIds: []
      })
    }
  },
  data () {
    return {
      dataIconPlay: faPlay,
      dataModal: this.value,
      dataSelectOptionsCountTasks: [
        { id: 10, name: '10' },
        { id: 30, name: '30' },
        { id: 50, name: '50' },
        { id: 100, name: '100' },
        { id: null, name: 'All' }
      ],
      dataForm: {
        name: '',
        countTasks: { id: 10, name: '10' },
        weekday: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        time: [
          moment
            .utc(new Date('2026-06-27T09:00:00.000Z'))
            .local(true)
            .toDate(),
          moment
            .utc(new Date('2026-06-27T19:00:00.000Z'))
            .local(true)
            .toDate()
        ]
      }
    };
  },
  validations: {
    dataForm: {
      name: {
        required
      }
    }
  },

  computed: {
    settingsData () {
      return this.projectData?.settings?.auto_calls || null;
    }
  },

  watch: {
    async value () {
      this.dataModal = this.value;
      if (this.dataModal) {
        if (this.settingsData) {
          this.setEditParams(this.settingsData);
        }

        Object.assign(this.$data, this.$options.data.apply(this));
        this.$v.$reset();
      }
    }
  },
  methods: {
    setEditParams (paramsSettings) {
      const countTasks = paramsSettings.tasks_all
        ? { id: null, name: 'All' }
        : this.dataSelectOptionsCountTasks.filter(
          task => task.id === paramsSettings.tasks_count
        )[0];

      const time = [
        moment
          .utc(new Date(`2026-06-27T${paramsSettings.period_start}.000Z`))
          .local(true)
          .toDate(),
        moment
          .utc(new Date(`2026-06-27T${paramsSettings.period_end}.000Z`))
          .local(true)
          .toDate()
      ];

      const weekday = paramsSettings.days;

      this.$nextTick(() => {
        this.$set(this.dataForm, 'name', name);
        this.$set(this.dataForm, 'countTasks', countTasks);
        this.$set(this.dataForm, 'weekday', weekday);
        this.$set(this.dataForm, 'time', time);
      });
    },

    onCloseModal () {
      this.$emit('input', false);
    },
    async clickAdd () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      try {
        if (this.dataAutoCallProjectsSettings.type === 'main') {
          const params = {
            name: this.dataForm.name,
            project_id: this.projectId,
            days: this.dataForm.weekday,
            period_start: moment(this.dataForm.time[0]).format('HH:mm:ss'),
            period_end: moment(this.dataForm.time[1]).format('HH:mm:ss'),
            tasks_all: !this.dataForm.countTasks.id,
            ...(this.dataForm.countTasks.id
              ? { tasks_count: this.dataForm.countTasks.id }
              : {})
          };

          await this.$store.dispatch(`autocall/${AUTOCALL_UPDATE}`, {
            params,
            context: this
          });
        } else {
          const params = {
            name: this.dataForm.name,
            project_id: Number(this.projectId, 10),
            days: this.dataForm.weekday,
            period_start: moment(this.dataForm.time[0]).format('HH:mm:ss'),
            period_end: moment(this.dataForm.time[1]).format('HH:mm:ss'),
            task_ids: this.dataAutoCallProjectsSettings.selectedTaskIds
          };

          await this.$store.dispatch(`autocall/${AUTOCALL_CUSTOM}`, {
            params,
            context: this
          });
        }
        this.onCloseModal();
        this.$emit('on-update');
      } catch (e) {
        throw Error(e);
      }
    }
  }
};
</script>

<style lang="scss">
.model-project-settings {
  .upload__title {
    margin-bottom: 16px;
  }
  .wrapper-select-period {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    .vs__selected {
      margin: 0 !important;
    }

    input {
      height: 25px;
    }
  }
  .call-input {
    margin-bottom: 16px;
  }

  .call-input input {
    height: 26px !important;
  }

  .mx-datepicker svg {
    fill: #000;
  }

  &__cts-wrap {
    width: 100%;
    display: flex;
    padding: 12px 16px;
    border-radius: 8px;
    background-color: #e8f5ed;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #222;
    margin-bottom: 16px;
  }
}

.my-time-picker .mx-time-column {
  position: relative;
}

.my-time-picker .mx-time-column::before {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 600;
  z-index: 2;
  white-space: nowrap;
}

.my-time-picker .mx-time-content {
  padding-top: 35px;
  position: relative;
}

.my-time-picker .mx-time-content:nth-child(1)::before {
  content: "Hours";
  position: absolute;
  transform: translateX(100%);
  left: 0%;
  top: 4px;
  color: #333;
  font-weight: 400;
}
.my-time-picker .mx-time-content:nth-child(1)::after {
  content: "Minutes";
  position: absolute;
  transform: translateX(50%);
  left: 50%;
  top: 4px;
  color: #333;
  font-weight: 400;
}
.my-time-picker .mx-time-content:nth-child(2)::before {
  content: "Hours";
  position: absolute;
  transform: translateX(100%);
  left: 0%;
  top: 4px;
  color: #333;
  font-weight: 400;
}
.my-time-picker .mx-time-content:nth-child(2)::after {
  content: "Minutes";
  position: absolute;
  transform: translateX(50%);
  left: 50%;
  top: 4px;
  color: #333;
  font-weight: 400;
}

.my-time-picker {
  .mx-btn {
    border-radius: 8px;
    &:hover {
      color: #20a052;
      border-color: #20a052;
    }
  }
  .mx-time-item {
    color: #333;
    &.active {
      color: #20a052;
    }
  }
  .mx-time-item {
    &:hover {
      background-color: #20a05136;
      color: #333;
    }
  }
}
</style>
